/**
 * Decodes HTML entities in a string
 * @param text - The text containing HTML entities
 * @returns The decoded text
 */
export const decodeHTMLEntities = (text: string): string => {
  return text.replace(/&amp;/g, '&');
};
